function cursorAnim() {
  const cursor = document.querySelector('.js-cursor');
  if(!cursor) return;

  const links = document.querySelectorAll('.js-cursor__link');

  links.forEach((link) => {
    link.addEventListener('mousemove', (e) => {

      const rect = link.getBoundingClientRect();

      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      link.style.setProperty('--x', `${x}px`);
      link.style.setProperty('--y', `${y}px`);
    });
  });
}

export { cursorAnim };